var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ButtonGroup",
    { staticClass: "mb-2@large" },
    [
      _c(
        "a",
        {
          staticClass: "btn w-100",
          attrs: { target: "_blank", disabled: !_vm.configurationComplete },
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.goToPersonalisazion.apply(null, arguments)
            },
          },
        },
        [
          _vm._v(
            "\n    " +
              _vm._s(_vm._f("translate")("ttxtDesignOnline")) +
              "\n    "
          ),
          _c(
            "svg",
            {
              staticClass: "svg-icon ml-2 fill-white",
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 12.8 12.8",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M8.7 6.4c0 .2-.1.3-.2.5L5 10.7l-1-.9 3-3.4L4.1 3l1-.9 3.5 3.8c.1.2.1.3.1.5z",
                  fill: "#3a3a39",
                },
              }),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "DownloadTemplate",
        {
          attrs: {
            name: "download-template",
            conf3DModel:
              _vm.configuratorService.byConfigoptionType("Printq").dynamicValues
                .conf3DModel,
            printqService: this.printqService,
          },
        },
        [
          _c(
            "a",
            {
              staticClass: "btn w-100",
              attrs: { disabled: !_vm.configurationComplete },
              on: {
                click: function ($event) {
                  return _vm.$modal.show("download-template")
                },
              },
            },
            [
              _c(
                "svg",
                {
                  staticClass: "svg-icon icon-download mr-2 fill-white",
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 11.92 12.76",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M.75 12.76a1 1 0 01-.51-.28.85.85 0 01-.24-.6V9a.85.85 0 011.19-.81.84.84 0 01.54.84v1.82c0 .14 0 .14.13.14h8.2c.13 0 .13 0 .13-.13V9.09a.87.87 0 01.36-.75.82.82 0 01.85-.09.8.8 0 01.51.67 1.21 1.21 0 010 .19v2.72a.89.89 0 01-.24.66.94.94 0 01-.43.25h-.08z",
                      fill: "#3a3a39",
                      "fill-rule": "evenodd",
                    },
                  }),
                  _vm._v(" "),
                  _c("path", {
                    attrs: {
                      d: "M6.19 0a2.43 2.43 0 01.37.16.84.84 0 01.38.73v5.42l.22-.21c.3-.3.6-.61.91-.91a.85.85 0 011.07-.11.87.87 0 01.34 1 1.26 1.26 0 01-.35.47L7.72 8 6.65 9a.88.88 0 01-1.24 0L3.78 7.34c-.33-.33-.67-.66-1-1a.8.8 0 01-.13-.85.85.85 0 01.69-.49 1 1 0 01.85.35c.31.32.62.62.93.93l.08.07V1a.93.93 0 01.21-.69.87.87 0 01.46-.31H6z",
                      fill: "#3a3a39",
                      "fill-rule": "evenodd",
                    },
                  }),
                ]
              ),
              _vm._v(
                "\n      " +
                  _vm._s(_vm._f("translate")("txtDownloadTemplate")) +
                  "\n    "
              ),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }